import type { roles as en } from '@/i18n/locales/en/roles';
import type { Translation } from '@/i18n/types';

export const roles: Translation<typeof en> = {
  form: {
    person: 'Persona',
    choose: 'Scegli…',
    grant: 'Concedi {{label}}',
    revoke: 'Revoca {{label}}',
    back: 'Indietro',
  },
  company: {
    title: 'Amministratori dell’azienda',
    lead: 'Un amministratore dell’azienda gestisce le informazioni proprie dell’azienda, i reparti, i membri e il provisioning. Concessione e revoca vengono registrate nel controllo.',
    label: 'amministratore dell’azienda',
    rowsLabel: 'i membri dell’azienda',
  },
  department: {
    title: 'Amministratori di reparto (allenatore)',
    lead: 'Un amministratore di reparto legge i membri e gli aggregati di questo reparto e, secondo la regola dell’accesso individuale, le statistiche individuali coperte dalla sua base di consenso. Concessione e revoca vengono registrate nel controllo.',
    label: 'amministratore di reparto',
    rowsLabel: 'i membri del reparto',
  },
  admins: {
    title: 'Amministratori della piattaforma',
    lead: 'Un amministratore della piattaforma detiene ogni autorità in ogni ambito. Il destinatario di una nomina deve avere un proprio accesso ed essere un’identità principale; l’ultimo amministratore non può essere revocato.',
    name: 'Nome',
    email: 'E-mail',
    retire: 'Revoca',
    rowsLabel: 'gli amministratori',
    searchPeople: 'Cerca persone',
    searchPlaceholder: 'Nome o e-mail',
    person: 'Persona',
    choose: 'Scegli…',
    noEligible: 'Nessuna persona idonea corrisponde — deve avere un proprio accesso.',
    appoint: 'Nomina',
    usersLabel: 'gli utenti della piattaforma',
  },
};
